import AppRoutes from "./Routes/appRoutes";




function App() {
  return <AppRoutes />;
}


export default App;
